import useSWR from 'swr';
import { analyticsService, WorkflowOverviewResponse } from '../services/analyticsService';

interface UseWorkflowOverviewReturn {
  overview: WorkflowOverviewResponse | undefined;
  loading: boolean;
  error: Error | undefined;
}

export const useWorkflowOverview = (year: number): UseWorkflowOverviewReturn => {
  const { data, error, isLoading } = useSWR<WorkflowOverviewResponse, Error>(
    `/api/v1/analytics/service/workflow/overview?year=${year}`,
    () => analyticsService.getWorkflowOverview(year),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      dedupingInterval: 5000,
    }
  );

  return {
    overview: data,
    loading: isLoading,
    error,
  };
};
